import React, { Children } from 'react'
import Header from './header'
import Sidebar from './sidebar'
import {Outlet} from 'react-router-dom'
// import Dashboard from '../../Pages/dashboard'

function Layout({Children}) {
  return (
    <>
    <Header/>
    <Sidebar/>
    {/* <Dashboard/> */}
    <Outlet/>
    {Children}
    </>
  )
}

export default Layout